import { useCallback, useState } from 'react';

let toastId = 0;

export function useToast() {
    const [toasts, setToasts] = useState([]);

    const addToast = useCallback((message, type = 'success', duration = 3000) => {
        const id = ++toastId;
        setToasts((prev) => [...prev, { id, message, type, duration }]);
        return id;
    }, []);

    const removeToast = useCallback((id) => {
        setToasts((prev) => prev.filter((toast) => toast.id !== id));
    }, []);

    const showSuccess = useCallback(
        (message, duration) => {
            return addToast(message, 'success', duration);
        },
        [addToast],
    );

    const showError = useCallback(
        (message, duration) => {
            return addToast(message, 'error', duration);
        },
        [addToast],
    );

    const showInfo = useCallback(
        (message, duration) => {
            return addToast(message, 'info', duration);
        },
        [addToast],
    );

    const showWarning = useCallback(
        (message, duration) => {
            return addToast(message, 'warning', duration);
        },
        [addToast],
    );

    return {
        toasts,
        addToast,
        removeToast,
        showSuccess,
        showError,
        showInfo,
        showWarning,
    };
}
